import Phaser from 'phaser';

const BG_OUTER = 0x2e1065;
const BG_INNER = 0x4c1d95;
const GEM_DARK = 0x6d28d9;
const GEM_MID = 0xa855f7;
const GEM_LIGHT = 0xd8b4fe;
const AURA = 0xfde68a;
const MIND_STONE = 0xfbbf24;
const STONE_CORE = 0xffffff;
const STROKE = 0x0a0f1f;

export function drawGem(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  g.fillStyle(AURA, 0.3);
  g.fillCircle(0, 0, r * 0.82);

  const gemW = r * 1.0;
  const gemH = r * 1.35;

  g.fillStyle(GEM_DARK, 1);
  g.beginPath();
  g.moveTo(0, -gemH * 0.5);
  g.lineTo(gemW * 0.5, 0);
  g.lineTo(0, gemH * 0.5);
  g.lineTo(-gemW * 0.5, 0);
  g.closePath();
  g.fillPath();

  g.fillStyle(GEM_MID, 1);
  g.beginPath();
  g.moveTo(0, -gemH * 0.5);
  g.lineTo(gemW * 0.25, -gemH * 0.15);
  g.lineTo(0, 0);
  g.lineTo(-gemW * 0.25, -gemH * 0.15);
  g.closePath();
  g.fillPath();

  g.fillStyle(GEM_LIGHT, 0.85);
  g.beginPath();
  g.moveTo(-gemW * 0.12, -gemH * 0.3);
  g.lineTo(gemW * 0.12, -gemH * 0.3);
  g.lineTo(0, -gemH * 0.05);
  g.closePath();
  g.fillPath();

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.8)), STROKE, 1);
  g.beginPath();
  g.moveTo(0, -gemH * 0.5);
  g.lineTo(gemW * 0.5, 0);
  g.lineTo(0, gemH * 0.5);
  g.lineTo(-gemW * 0.5, 0);
  g.closePath();
  g.strokePath();

  g.fillStyle(MIND_STONE, 1);
  g.fillCircle(0, -gemH * 0.28, r * 0.14);
  g.fillStyle(STONE_CORE, 1);
  g.fillCircle(0, -gemH * 0.28, r * 0.06);
}
